export default __webpack_public_path__ + "media/fonts/GTWalsheim/gt-walsheim-web-118d78e1ae1813cb5128895b13730103.eot";